module.exports = __webpack_public_path__ + "static/sparkle_loading_version_2-1ffae5a61812de7d265ab6a76d56ce7c.gif";